import { Outlet, Navigate } from 'react-router-dom';

import AuthUtility from './components/frontend/auth/AuthUtility';

const AdminPrivateRoutes = () => {
	
    let auth = {'token':false, 'role':'none'};
	let nav_path = '';

	if (AuthUtility.isLoggedIn()) {
		
		auth.token = true;
		
		if(localStorage.getItem('auth_role') === 'user'){
			auth.role = 'user';
			nav_path = 'user/account';
		}else if(localStorage.getItem('auth_role') === 'member'){
			auth.role = 'member';
			nav_path = 'member/account';
		}else if(localStorage.getItem('auth_role') === 'admin'){
			auth.role = 'admin';
		}
	}else{
			nav_path = '/login';
	}
		
    return(
        auth.token && auth.role === 'admin' ? <Outlet/> : <Navigate to={nav_path}/>
    )
}

export default AdminPrivateRoutes